module.exports = __webpack_public_path__ + "img/03.bc8f936e.png";